module.exports = __webpack_public_path__ + "static/media/jerry.63ffa754.jpg";